import React from "react";
import ReactDOM from 'react-dom';
import {
  cyan500, cyan700,
  pinkA200,
  grey100, grey300, grey400, grey500, indigo,
  white, darkBlack, fullBlack, cyan, blueGrey, grey
} from '@material-ui/core/colors';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import App from './app/container';

import store from './store';
import { Provider } from 'react-redux';

import MapIni from './map/map';

import baseLayersMapCont from './baseLayers/mapContainer';
import mapContainer from './map/mapContainer';
import piechart from './schoolQualityIndicators/piechart';
import populationMapCont from './population/mapContainer';
import industriesContainer from './mapData/mapContainer';
import drawContainer from './draw/mapContainer';
import electricUsageMapContainer from './electricUsage/mapContainer';
import sliderMapContainer from './slider/map';
import memorialEventsContainer from './memorialEvents/mapContainer';
import urlContainer from './urlRouting/urlContainer';

const muiTheme = createMuiTheme({
  palette: {
    primary: grey,
  
  }
  
});

//injectTapEventPlugin();

const MuiWrap = () => (<Provider store={store}>
  			<MuiThemeProvider theme={muiTheme}>
    		<App />
  		</MuiThemeProvider>
   </Provider>);

ReactDOM.render(
  <MuiWrap />,
  document.getElementById('app')
);


baseLayersMapCont(store);
piechart(store);
populationMapCont(store);
industriesContainer(store);
electricUsageMapContainer(store);
sliderMapContainer(store);
drawContainer(store);
urlContainer(store);
mapContainer(store);
memorialEventsContainer(store);


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/index.js